module.exports = __webpack_public_path__ + "img/D2021_4.10afc552.jpg";